import axiosAuth from '../../axios/auth';
var qs = require( 'qs' ); // necessary for stringifying json for http requests to API

import router from '../../router/router';
import { routes } from '../../router/routes';

// resources:
//  https://morningstar.engineering/managing-your-vue-js-applications-state-with-vuex-part-2-5e5c3a0cd507
//  https://stackoverflow.com/questions/46234832/structuring-a-vuex-module

// indexDB reference: https://developers.google.com/web/ilt/pwa/lab-indexeddb
import idb from 'idb';

const state = {

    cardsCached : JSON.parse( localStorage.getItem( 'cardsCached' ) ) || true,
    wallet      : [],
    currentCard : JSON.parse( localStorage.getItem( 'currentCard' ) ) || null
};

const mutations = {

    setCards( state, data ){

        // console.log( 'data coming through..', data );
        if( data.body.length > 0 ){

            let dbPromise = idb.open( 'quickOrdersDB', data.idbVersion );
            dbPromise.then( db => {

                let txCategories = db.transaction( 'cardWallet', 'readwrite' );
                txCategories.objectStore( 'cardWallet' ).clear();
                data.body.forEach( value => {

                    // console.log( 'cards data: ', value );
                    txCategories.objectStore( 'cardWallet' ).put( value );
                    state.wallet.push( value );
                });
            });
        }
        const timestamp = parseInt( new Date().getTime() );
        state.cardsCached = timestamp;
        localStorage.setItem( 'cardsCached', timestamp );
    },
    toggleCache( state ){ // not up to date with the new timestamp-cache strategy, DO NOT USE UNLESS UPDATED

        console.log( 'old cache: ', state.cardsCached );
        state.cardsCached = !state.cardsCached;
        console.log( 'new cache: ', state.cardsCached );
        localStorage.setItem( 'cardsCached', state.cardsCached );
    },
    viewCard( state, cardId ){

        localStorage.setItem( 'currentCard', cardId );
        state.currentCard = cardId;
    },
    clearState( state ){

        state.wallet = [];

        state.cardsCached = null;
        localStorage.removeItem( 'cardsCached' );

        state.currentCard = null;
        localStorage.removeItem( 'currentCard' );
    }
};

const actions = {

    getCards( { commit, getters, rootGetters } ){

        if( parseInt( getters.cardsCached ) + parseInt( 5 * 60 * 1000 ) < parseInt( new Date().getTime() ) ){ // only load if not cached within recently

            axiosAuth({

                method: 'post',
                url: '/getCardWallet',
                data: '',
                headers: {

                    'Content-Type' : 'application/x-www-form-urlencoded',
                    'AuthType'     : 'JWT',
                    'ApiKey'       : process.env.VUE_APP_API_KEY,
                    'Token'        : localStorage.getItem( 'token' ) || null
                }
            }).then( res => {

                // console.log( 'result: ', res.data );
                if( res.data.responseCode == 100 ){

                    // run a diff
                    if( getters.wallet.length > 0 ){ // we have some currently loaded

                        res.data.body.forEach( ( card, key ) => {

                            for( let i = 0; i < getters.wallet.length; i++ ){

                                if( card.PrepaidAccount.prepaidAccountId == getters.wallet[ i ].PrepaidAccount.prepaidAccountId ){

                                    res.data.body[ key ].alreadyExists = true;
                                    break;
                                }
                            }
                        });

                        const newCards = res.data.body.filter( card => !card.alreadyExists );
                        const payload = {

                            body       : newCards, // only push the new ones not previously seen
                            idbVersion : rootGetters[ 'idbVersion' ]
                        };
                        commit( 'setCards', payload );
                    } else {

                        const payload = {

                            body       : res.data.body,
                            idbVersion : rootGetters[ 'idbVersion' ]
                        };
                        commit( 'setCards', payload );
                    }
                } else {

                    console.log( 'server error' );
                }
            }).catch( err => {

                console.error( 'error! ', err );
            });
        }
    },
    toggleCache( { commit } ){

        commit( 'toggleCache' );
    },
    viewCard( { commit }, card ){

        commit( 'viewCard', card.PrepaidAccount.prepaidAccountId );
        router.push( { name: 'view-card' } );
    },
    clearState( { commit } ){

        commit( 'clearState' );
    }
};

const getters = {

    cardsCached : state => state.cardsCached,
    wallet      : state => state.wallet,
    currentCard( state ){

        return state.wallet.filter( card => {

            if( card.PrepaidAccount.prepaidAccountId == state.currentCard ) return card;
        })[ 0 ];
    }
};

export default {

    namespaced: true,
    state,
    mutations,
    actions,
    getters
};